import React from 'react';
import ModuleRoute from 'holocron-module-route';
import requireAuth from './utils/requireAuth';
import selectProductRedirect from './utils/selectProductRedirect';
import SessionManager from './components/SessionManager';
import updateLocaleFromRoute from './utils/updateLocaleFromRoute';

export const getTitleFromStore = (store) => (key) => () => {
  const state = store.getState();
  const locale = state.getIn(['intl', 'activeLocale']);
  const langPack = state.getIn(['intl', 'languagePacks', locale, 'axp-document-communications-root'], {});
  return langPack[key] || key;
};

const childRoutes = (store) => {
  const getTitle = getTitleFromStore(store);
  return [
    <ModuleRoute moduleName="axp-page-wrapper" onEnter={updateLocaleFromRoute(store)}>
      <ModuleRoute component={SessionManager}>
        <ModuleRoute onEnter={selectProductRedirect(store)}>
          <ModuleRoute onEnter={requireAuth(store, undefined, true)}>
            <ModuleRoute path="(:locale/)account/document-centre" getTitle={getTitle('Document Centre')} moduleName="axp-document-center" />
            <ModuleRoute path="(:locale/)account/document-center" getTitle={getTitle('Document Center')} moduleName="axp-document-center" />
            <ModuleRoute path="(:locale/)compte/centre-de-documentation" getTitle={getTitle('Centre De Documentation')} moduleName="axp-document-center" />
            <ModuleRoute path="(:locale/konto/last-opp-dokument)" getTitle={getTitle('Last opp Dokumenter')} moduleName="axp-document-center" />
            <ModuleRoute path="(:locale/tili/lataa-asiakirja)" getTitle={getTitle('Lataa asiakirjoja')} moduleName="axp-document-center" />
            <ModuleRoute path="(:locale/account/centre-document)" getTitle={getTitle('Centre Document')} moduleName="axp-document-center" />
            <ModuleRoute path="(:locale/account/documentenportaal)" getTitle={getTitle('DocumentenPortaal')} moduleName="axp-document-center" />
            <ModuleRoute path="(:locale/konto/ladda-upp-dokument)" getTitle={getTitle('ladda upp Dokument')} moduleName="axp-document-center" />
            <ModuleRoute path="(:locale/)account/touchpoint" getTitle={getTitle('Touchpoint')} moduleName="axp-communication-timelines" />
          </ModuleRoute>
        </ModuleRoute>
      </ModuleRoute>
    </ModuleRoute>,
    <ModuleRoute path="demo/:moduleName" moduleName="axp-demo" />,
  ];
};

export default childRoutes;
